import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

const styles = () => ({
  root: {
    alignItems: 'stretch',
    display: 'flex',
    flex: 1,
  },
});

const useStyles = makeStyles(styles);

interface Props {
  className?: string;
  children: React.ReactNode;
}

export function MasterView({ children, className, ...props }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)} {...props}>
      {children}
    </div>
  );
}
